import {Component, Input, OnInit} from '@angular/core';
import { ContractEntity } from '../../../../handlers/app-entity-handler.service';
import { AppContext } from '../../../../app-context';
import { View } from '../../../../common/view';
import { RefdataUtils } from '../../refdata-utils';
import { Organisation} from "@flowmaps/flowmaps-typescriptmodels";
import {lodash} from "../../../../common/utils";

@Component({
    selector: 'app-move-contract-modal',
    templateUrl: './move-contract-modal.component.html',
})
export class MoveContractModalComponent extends View implements OnInit{
    appContext = AppContext;
    refDataUtils = RefdataUtils;

    @Input() data: ContractEntity;
    targetOrganisation: any = null;
    organisation: Organisation;

    ngOnInit() {
        this.organisation = lodash.cloneDeep(this.data.organisation);
    }

    searchOrganisations = (term: string) => this.sendQuery('searchOrganisations', term);

    onTargetOrgChange(org: any) {
        this.targetOrganisation = org;
    }

    moveContract = () => {
        if (!this.data?.contract?.contractId || !this.targetOrganisation?.organisationId) return;
        this.sendCommand("com.flowmaps.api.organisation.MoveContract", {
            contractId: this.data.contract.contractId,
            organisationId: this.organisation.organisationId,
            targetOrganisationId: this.targetOrganisation.organisationId
        });
    };

}
